<template>
  <v-container fluid>
    <v-card>
      <v-expansion-panels v-model="filterExpansionPanel" flat multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            {{ $vuetify.lang.t('$vuetify.FILTERS') }}
          </v-expansion-panel-header>
          <v-form @submit.prevent>
            <v-expansion-panel-content>
              <v-row>
                <v-col
                  ccols="12"
                  md="2"
                  sm="6"
                  class="pt-0 d-flex align-center"
                >
                  <v-menu
                    v-model="validFromPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          selectedValidFrom !== ''
                            ? datePickerFormat(selectedValidFrom)
                            : ''
                        "
                        :label="$vuetify.lang.t('$vuetify.STATISTICS.FROM')"
                        :placeholder="
                          $vuetify.lang.t('$vuetify.STATISTICS.FROM')
                        "
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        clearable
                        v-bind="attrs"
                        @click:clear="validFrom = null"
                        @click:append="validFromPicker = !validFromPicker"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="selectedValidFrom"
                      @input="validFromPicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="2" sm="6" class="pt-0 d-flex align-center">
                  <v-menu
                    v-model="validToPicker"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="
                          selectedValidTo !== ''
                            ? datePickerFormat(selectedValidTo)
                            : ''
                        "
                        :label="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                        :placeholder="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                        append-icon="mdi-calendar"
                        readonly
                        outlined
                        hide-details
                        clearable
                        v-bind="attrs"
                        @click:clear="selectedValidTo = null"
                        @click:append="validToPicker = !validToPicker"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="selectedValidTo"
                      @input="validToPicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-select
                    v-model="selectedStatus"
                    hide-details
                    outlined
                    :items="['UNPAID', 'PAID', 'VOID', 'WARNING']"
                    clearable
                    :label="$vuetify.lang.t('$vuetify.STATUS')"
                    @clear="selectedStatus = ''"
                  ></v-select>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="carNumber"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')"
                    :aria-label="
                      $vuetify.lang.t('$vuetify.DASHBOARD.CAR_NUMBER')
                    "
                    outlined
                  >
                    <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="location"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.LOCATION')"
                    :aria-label="$vuetify.lang.t('$vuetify.LOCATION')"
                    outlined
                  >
                    <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="zone"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.ZONE')"
                    :aria-label="$vuetify.lang.t('$vuetify.ZONE')"
                    outlined
                  >
                    <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-select
                    v-model="selectedReason"
                    item-text="code"
                    hide-details
                    outlined
                    :items="availableReasons"
                    clearable
                    :label="$vuetify.lang.t('$vuetify.ENFORCEMENT.REASON')"
                    @clear="selectedStatus = ''"
                  ></v-select>
                </v-col>
                <v-col
                  v-if="isGlobalAdmin"
                  cols="4"
                  md="2"
                  class="pt-0 d-flex align-center"
                >
                  <v-text-field
                    v-model="enforcer"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCER')"
                    :aria-label="
                      $vuetify.lang.t('$vuetify.ENFORCEMENT.ENFORCER')
                    "
                    outlined
                  >
                    <!-- <v-icon slot="append">mdi-magnify</v-icon> -->
                  </v-text-field>
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="id"
                    hide-details
                    clearable
                    :label="$vuetify.lang.t('$vuetify.ENFORCEMENT.ID')"
                    :aria-label="$vuetify.lang.t('$vuetify.ENFORCEMENT.ID')"
                    outlined
                    type="number"
                  />
                </v-col>
                <v-col cols="4" md="2" class="pt-0 d-flex align-center">
                  <v-text-field
                    v-model="referenceNumber"
                    hide-details
                    clearable
                    :label="
                      $vuetify.lang.t('$vuetify.ENFORCEMENT.REFERENCE_NUMBER')
                    "
                    :aria-label="
                      $vuetify.lang.t('$vuetify.ENFORCEMENT.REFERENCE_NUMBER')
                    "
                    outlined
                  />
                </v-col>
                <v-col cols="12" md="2" sm="6" class="pt-0 d-flex align-center">
                  <v-btn
                    color="success"
                    type="submit"
                    @click="searchParkingFines()"
                  >
                    {{ $vuetify.lang.t('$vuetify.SEARCH') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-form>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card-text>
        <v-data-table
          :items="parkingFines"
          :headers="[
            {
              text: 'ID',
              align: 'start',
              sortable: true,
              value: 'id'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.REFERENCE_NUMBER'),
              align: 'start',
              sortable: true,
              value: 'referenceNumber'
            },
            {
              text: $vuetify.lang.t('$vuetify.STATUS'),
              align: 'start',
              sortable: false,
              value: 'status'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.CREATED_AT'),
              align: 'start',
              sortable: true,
              value: 'createdAt'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.OVERDUE'),
              align: 'start',
              sortable: true,
              value: 'overdue'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.FINE_PAYMENT_DATE'),
              align: 'start',
              sortable: true,
              value: 'paymentDate',
              width: '7%'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.REASON'),
              align: 'start',
              sortable: false,
              value: 'reason'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.VOID_TIME'),
              align: 'start',
              sortable: false,
              value: 'voidTime'
            },
            {
              text: $vuetify.lang.t('$vuetify.CAR_NUMBER'),
              align: 'start',
              sortable: false,
              value: 'vehicleNumber'
            },
            {
              text: $vuetify.lang.t(
                '$vuetify.ENFORCEMENT.VEHICLE_NUMBER_COUNTRY'
              ),
              align: 'start',
              sortable: false,
              value: 'vehicleNumberCountry'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.LOCATION'),
              align: 'start',
              sortable: false,
              value: 'location'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.LAST_AMOUNT'),
              align: 'start',
              sortable: false,
              value: 'lastAmountInCents'
            },
            {
              text: $vuetify.lang.t('$vuetify.COST'),
              align: 'start',
              sortable: true,
              value: 'amountInCents'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.ISSUER_NAME'),
              align: 'start',
              sortable: true,
              value: 'issuerName'
            },
            {
              text: $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBTS_SENT'),
              align: 'start',
              sortable: true,
              value: 'debtsSent',
              width: '7%'
            },
            {
              text: '',
              align: 'start',
              sortable: false,
              value: 'actions'
            }
          ]"
          class="elevation-1"
          hide-default-footer
          :items-per-page="id !== '' || referenceNumber !== '' ? -1 : 11"
          :loading="loading.state && loading.type === 'getParkingFines'"
          :item-class="itemRowBackground"
          @click:row="onRowClick"
        >
          <template v-slot:item.id="props">
            <td>
              <a
                v-if="isGlobalAdmin"
                :href="`/parking-fine/${props.item.id}`"
                class="black--text no-underline"
                @click.stop=""
                >{{ props.item.id }}</a
              >
              <span v-else>{{ props.item.id }}</span>
            </td>
          </template>
          <template v-slot:item.createdAt="props">
            <td>{{ dateEE(props.item.createdAt) }}</td>
          </template>
          <template v-slot:item.voidTime="props">
            <td
              v-if="
                props.item.voidTime &&
                  props.item.voidTime !== '0001-01-01T00:00:00Z'
              "
            >
              {{ dateEE(props.item.voidTime) }}
            </td>
            <td v-else>
              -
            </td>
          </template>
          <template v-slot:item.status="props">
            <td>
              <span class="font-weight-bold">{{ props.item.status }}</span>
            </td>
          </template>
          <template v-slot:item.overdue="props">
            <td v-if="props.item.status === 'UNPAID'">
              <span>{{
                dayDiff(new Date(props.item.createdAt), new Date())
              }}</span>
            </td>
            <td v-else>
              -
            </td>
          </template>
          <template v-slot:item.location="props">
            <td v-if="props.item.location && props.item.location !== ''">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span v-on="on">
                    {{ props.item.location }}
                  </span>
                </template>
                <span v-if="props.item.place.price24h > 0">
                  24h: {{ props.item.place.price24h }}€
                </span>
                <span v-else>
                  -
                </span>
              </v-tooltip>
            </td>
            <td v-else>
              -
            </td>
          </template>
          <template v-slot:item.issuerName="props">
            <td
              v-if="
                props.item.issuerName &&
                  props.item.issuerName !== '' &&
                  isGlobalAdmin
              "
            >
              {{ props.item.issuerName }}
            </td>
            <td v-else>
              -
            </td>
          </template>
          <template v-slot:item.debtsSent="props">
            <td v-if="props.item.debtsSent">
              <v-icon color="green">mdi-check</v-icon>
              {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBTS_SENT_YES') }}
              &nbsp;({{ dateEE(props.item.debtsSentTime) }})
            </td>
            <td v-else>
              {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.DEBTS_SENT_NO') }}
            </td>
          </template>
          <template v-slot:item.paymentDate="props">
            <td v-if="props.item.status === 'PAID'">
              {{ props.item.paymentDate }}
            </td>
            <td v-else>
              -
            </td>
          </template>
          <template v-slot:item.lastAmountInCents="props">
            <td>
              {{ (props.item.lastAmountInCents / 100).toFixed(2) }}
              {{ props.item.currency }}
            </td>
          </template>
          <template v-slot:item.amountInCents="props">
            <td>
              {{ (props.item.amountInCents / 100).toFixed(2) }}
              {{ props.item.currency }}
            </td>
          </template>
          <template v-slot:item.actions="props">
            <td>
              <v-tooltip
                v-if="props.item.images && props.item.images.length"
                top
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    :style="
                      props.item.images && props.item.images.length
                        ? 'visibility: visible;'
                        : 'visibility: hidden;'
                    "
                    :class="
                      props.item.images && props.item.images.length
                        ? 'primary--text'
                        : 'error--text'
                    "
                    @click.stop="openImageDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-image</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.LOOK_IMAGES') }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="isGlobalAdmin" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :style="
                      props.item.status !== 'PAID' &&
                      props.item.status !== 'VOID'
                        ? 'visibility: visible;'
                        : 'visibility: hidden;'
                    "
                    icon
                    color="success"
                    @click.stop="openMarkFineAsPaidDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-check</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.MARK_AS_PAID') }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="canShowCancelParkingFineButton(props.item)" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :style="
                      props.item.status !== 'PAID' &&
                      props.item.status !== 'VOID'
                        ? 'visibility: visible;'
                        : 'visibility: hidden;'
                    "
                    icon
                    color="error"
                    @click.stop="openCancelFineDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-cancel</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.ENFORCEMENT.CANCEL_FINE') }}
                </span>
              </v-tooltip>
              <v-tooltip v-if="isGlobalAdmin" top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    :disabled="
                      props.item.status === 'PAID' ||
                      props.item.status === 'VOID' ||
                      props.item.status === 'WARNING'
                        ? true
                        : false
                    "
                    icon
                    @click.stop="openEditParkingFineDialog(props.item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
        <v-toolbar color="transparent" class="elevation-0">
          <v-spacer></v-spacer>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="currentPageNumber === 0"
            @click="prevPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-left</v-icon>
          </v-btn>
          <v-btn fab color="primary" x-small readonly>
            {{ currentPageNumber + 1 }}
          </v-btn>
          <v-btn
            fab
            color="white"
            x-small
            class="ma-2"
            :disabled="!parkingFines.length"
            @click="nextPage()"
          >
            <v-icon color="rgba(0, 0, 0, 0.54)">mdi-menu-right</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-toolbar>
      </v-card-text>
    </v-card>
    <parking-fine-images-dialog
      v-if="parkingFineImagesDialog"
      :visible="parkingFineImagesDialog"
      :parking-fine="selectedFine"
      @close="
        parkingFineImagesDialog = false
        selectedFine = undefined
      "
    />
    <debt-income-dialog
      v-if="debtIncomeDialog"
      :visible="debtIncomeDialog"
      :parking-fine="selectedFine"
      @close="
        debtIncomeDialog = false
        selectedFine = undefined
      "
    />
    <mark-parking-fine-as-paid-dialog
      v-if="markFineAsPaidDialog"
      :visible="markFineAsPaidDialog"
      :parking-fine="selectedFine"
      @close="
        markFineAsPaidDialog = false
        selectedFine = undefined
      "
    />
    <cancel-parking-fine-dialog
      v-if="cancelFineDialog"
      :visible="cancelFineDialog"
      :parking-fine="selectedFine"
      @close="
        cancelFineDialog = false
        selectedFine = undefined
      "
    />
    <edit-parking-fine-dialog
      v-if="editParkingFineDialog"
      :visible="editParkingFineDialog"
      :parking-fine="selectedFine"
      @close="
        editParkingFineDialog = false
        selectedFine = undefined
      "
    />
    <parking-fine-detail-view-dialog
      v-if="parkingFineDetailViewDialog"
      :id="selectedFine.id"
      :visible="parkingFineDetailViewDialog"
      @close="
        parkingFineDetailViewDialog = false
        selectedFine = undefined
      "
    />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'ParkingFines',
  components: {
    ParkingFineImagesDialog: () =>
      import(
        /* webpackChunkName: "ParkingFineImagesDialog" */ '@/components/enforcement/ParkingFineImagesDialog.vue'
      ),
    DebtIncomeDialog: () =>
      import(
        /* webpackChunkName: "DebtIncomeDialog" */ '@/components/enforcement/DebtIncomeDialog.vue'
      ),
    MarkParkingFineAsPaidDialog: () =>
      import(
        /* webpackChunkName: "MarkParkingFineAsPaidDialog" */ '@/components/enforcement/MarkParkingFineAsPaidDialog.vue'
      ),
    CancelParkingFineDialog: () =>
      import(
        /* webpackChunkName: "CancelParkingFineDialog" */ '@/components/enforcement/CancelParkingFineDialog.vue'
      ),
    EditParkingFineDialog: () =>
      import(
        /* webpackChunkName: "EditParkingFineDialog" */ '@/components/enforcement/EditParkingFineDialog.vue'
      ),
    ParkingFineDetailViewDialog: () =>
      import(
        /* webpackChunkName: "ParkingFineDetailViewDialog" */ '@/components/enforcement/ParkingFineDetailViewDialog.vue'
      )
  },
  mixins: [formatDate],
  data() {
    return {
      parkingFineImagesDialog: false,
      debtIncomeDialog: false,
      markFineAsPaidDialog: false,
      editParkingFineDialog: false,
      cancelFineDialog: false,
      selectedFine: undefined,
      filterExpansionPanel: [0],
      validFromPicker: false,
      selectedValidFrom: '',
      validToPicker: false,
      selectedValidTo: '',
      selectedStatus: '',
      carNumber: '',
      location: '',
      zone: '',
      selectedReason: '',
      enforcer: '',
      currentPageNumber: 0,
      pageSize: 11,
      id: '',
      referenceNumber: '',
      parkingFineDetailViewDialog: false,
      reasons: []
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('enforcement', ['parkingFines', 'availableReasons']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin'])
  },
  created() {
    // Set selectedValidTo to current day
    this.selectedValidTo = this.formatDate(new Date())
    this.getParkingFines(
      `from=${this.serverFormat(this.selectedValidFrom)}&to=${this.serverFormat(
        this.selectedValidTo
      )}&page=${this.currentPageNumber}&page_size=${this.pageSize}`
    )
    this.getParkingFineReasons()
  },
  methods: {
    ...mapActions('enforcement', [
      'getParkingFines',
      'sendParkingFineToJulianus',
      'resetParkingFine',
      'getParkingFineReasons'
    ]),
    openImageDialog(parkingFine) {
      this.selectedFine = parkingFine
      this.parkingFineImagesDialog = true
    },
    openMarkFineAsPaidDialog(parkingFine) {
      this.selectedFine = parkingFine
      this.markFineAsPaidDialog = true
    },
    openCancelFineDialog(parkingFine) {
      this.selectedFine = parkingFine
      this.cancelFineDialog = true
    },
    openEditParkingFineDialog(parkingFine) {
      this.selectedFine = parkingFine
      this.editParkingFineDialog = true
    },
    openDebtIncomeDialog(parkingFine) {
      this.selectedFine = parkingFine
      this.debtIncomeDialog = true
    },
    resetFine(parkingFine) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.resetParkingFine(parkingFine)
        }
      })
    },
    sendToJulianus(parkingFine) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(async option => {
        if (option) {
          this.sendParkingFineToJulianus(parkingFine)
        }
      })
    },
    itemRowBackground(item) {
      let color = ''
      if (item.status !== 'VOID') {
        if (item.status === 'UNPAID') {
          if (this.dayDiff(new Date(item.createdAt), new Date()) <= 3) {
            color = 'backgroun-white'
          }
          if (
            this.dayDiff(new Date(item.createdAt), new Date()) > 3 &&
            this.dayDiff(new Date(item.createdAt), new Date()) <= 15
          ) {
            color = 'error-lighter'
          }
          if (this.dayDiff(new Date(item.createdAt), new Date()) > 15) {
            color = 'warning-lighter'
          }
        }
        if (item.status === 'PAID') {
          color = 'success-lighter'
        }
      }
      return color
    },

    dayDiff(startdate, enddate) {
      // Set time to 0, to calculate the day difference by comparing year, month, and day values
      startdate.setHours(0, 0, 0, 0)
      enddate.setHours(0, 0, 0, 0)

      const timeDiff = enddate - startdate
      const dayCount = timeDiff / (1000 * 60 * 60 * 24)

      return Math.floor(dayCount)
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    serverFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    nextPage() {
      if (this.parkingFines.length) {
        this.currentPageNumber += 1
        this.getParkingFines(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&fineStatus=${this
            .selectedStatus || ''}&carNumber=${this.carNumber ||
            ''}&reason=${this.selectedReason || ''}&location=${this.location ||
            ''}&zone=${this.zone || ''}&enforcer=${this.enforcer || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}&id=${this.id}&referenceNumber=${
            this.referenceNumber
          }`
        )
      }
    },
    prevPage() {
      if (this.currentPageNumber !== 0) {
        this.currentPageNumber -= 1
        this.getParkingFines(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&fineStatus=${this
            .selectedStatus || ''}&carNumber=${this.carNumber ||
            ''}&reason=${this.selectedReason || ''}&location=${this.location ||
            ''}&zone=${this.zone || ''}&enforcer=${this.enforcer || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}&id=${this.id}&referenceNumber=${
            this.referenceNumber
          }`
        )
      }
    },
    onRowClick(item) {
      if (!this.isGlobalAdmin) {
        return
      }
      this.selectedFine = item
      this.parkingFineDetailViewDialog = true
    },
    searchParkingFines() {
      if (this.referenceNumber && this.referenceNumber !== '') {
        this.getParkingFines(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&fineStatus=${this
            .selectedStatus || ''}&carNumber=${this.carNumber ||
            ''}&reason=${this.selectedReason || ''}&location=${this.location ||
            ''}&zone=${this.zone || ''}&enforcer=${this.enforcer || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}&id=${this.id}&referenceNumber=${
            this.referenceNumber
          }`
        )
      } else {
        this.getParkingFines(
          `from=${this.serverFormat(
            this.selectedValidFrom
          )}&to=${this.serverFormat(this.selectedValidTo)}&fineStatus=${this
            .selectedStatus || ''}&carNumber=${this.carNumber ||
            ''}&reason=${this.selectedReason || ''}&location=${this.location ||
            ''}&zone=${this.zone || ''}&enforcer=${this.enforcer || ''}&page=${
            this.currentPageNumber
          }&page_size=${this.pageSize}&id=${this.id}`
        )
      }
    },
    canShowCancelParkingFineButton(parkingFine) {
      if (this.isGlobalAdmin) {
        return true
      }
      if (this.user.canCancelParkingFines && !parkingFine.debtsSent) {
        return true
      }
      return false
    }
  }
}
</script>
<style scoped>
::v-deep .v-data-table tbody tr.warning-lighter {
  background-color: rgba(229, 131, 152, 0.2) !important;
}

::v-deep .v-data-table tbody tr.error-lighter {
  background-color: rgba(248, 192, 26, 0.2) !important;
}

::v-deep .v-data-table tbody tr.success-lighter {
  background-color: rgba(76, 175, 80, 0.2) !important;
}

.row-pointer:hover {
  cursor: pointer;
}

.no-underline {
  text-decoration: none;
}
</style>
